<template>
    <div
        class="modal fade"
        :class="isCloseSale ? 'show d-block' : 'd-none'"
        id="modal-close-sale"
        tabindex="-1"
        aria-labelledby="modal-close-sale"
        aria-modal="true"
        role="dialog"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content rounded-24 overflow-hidden">
                <div class="block rounded-24 block-transparent mb-0">
                    <div class="block-header">
                        <h3 class="block-title">Clôturer la vente</h3>
                        <div class="block-options">
                            <button
                                type="button"
                                class="btn-block-option"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                @click="$emit('close-sale-modal')"
                            >
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="block-content fs-sm">
                        <p>Voulez-vous clôturer la vente ?</p>
                        <div v-if="data.send_invoice" id="container_company" class="form-group mb-2">
                            <label class="form-label" for="customer_society_id-modal">Ajouter une société sur la facture</label>
                            <input
                                type="search"
                                class="form-control mb-2"
                                placeholder="Rechercher une société"
                                v-model="customer_society_search"
                            />
                            <select
                                required
                                class="form-select"
                                id="customer_society_id-modal"
                                v-model="data.customer_society_id"
                                @change="applySelectedSociety"
                            >
                                <option :value="null">Sélectionner une société</option>
                                <option v-for="society in filteredCustomerSocieties" :key="society.id" :value="society.id">
                                    {{ society.name }} - SIRET {{ society.siret }} - {{ society.city }}
                                </option>
                            </select>
                            <div v-if="selectedCustomerSociety" class="alert alert-info mt-3 mb-0">
                                {{ selectedCustomerSociety.address }} -
                                {{ selectedCustomerSociety.postal_code }} {{ selectedCustomerSociety.city }} -
                                {{ selectedCustomerSociety.country }}
                                <br />
                                SIREN : {{ selectedCustomerSociety.siren }} / SIRET : {{ selectedCustomerSociety.siret }}
                                <span v-if="selectedCustomerSociety.electronic_billing_number">
                                    <br />N° facturation électronique : {{ selectedCustomerSociety.electronic_billing_number }}
                                </span>
                            </div>
                            <div v-if="customerSocieties.length === 0" class="alert alert-warning mt-3 mb-0">
                                Aucune société active disponible. Créez une société depuis Clients &gt; Sociétés.
                            </div>
                            <div v-else-if="invoiceRequiresSociety" class="alert alert-danger mt-3 mb-0">
                                Sélectionnez une société pour générer une facture.
                            </div>
                        </div>
                        <div v-if="data.send_mail" class="mb-2">
                            <label class="form-label">Mail de remerciement</label>
                            <div class="form-check">
                                <input
                                    id="rebooking-modal"
                                    class="form-check-input"
                                    type="checkbox"
                                    :checked="data.rebooking"
                                    @change="
                                        event => {
                                            event.target.checked ? (data.rebooking = true) : (data.rebooking = false)
                                        }
                                    "
                                />
                                <label for="rebooking-modal" class="form-label">Offre de rebooking</label>
                            </div>
                            <div class="form-check">
                                <input
                                    id="notice-modal"
                                    class="form-check-input"
                                    type="checkbox"
                                    :checked="data.notice"
                                    @change="
                                        event => {
                                            event.target.checked ? (data.notice = true) : (data.notice = false)
                                        }
                                    "
                                />
                                <label for="notice-modal" class="form-label">Liens des avis</label>
                            </div>
                        </div>
                        <div class="d-flex flex-row pb-3">
                            <div class="form-switch p-0 pe-2">
                                <button
                                    type="button"
                                    role="button"
                                    class="btn btn-sm "
                                    :class="data.send_mail ? 'btn-info text-white' : 'btn-outline-info'"
                                    @click="
                                        () => {
                                            data.send_mail = !data.send_mail
                                            if(!data.send_mail) {
                                                data.rebooking = false
                                                data.notice = false
                                            }
                                        }
                                    "
                                    ref="sendMailBtn"
                                >
                                    <i
                                        class="fa fa-xs fa-fw fa-check pe-2"
                                        :class="data.send_mail ? 'd-inline-block' : 'd-none'"
                                        ref="sendMailIcon"
                                    ></i
                                    >Mail de remerciement
                                </button>
                            </div>
                            <div class="form-switch p-0">
                                <button
                                    type="button"
                                    role="button"
                                    class="btn btn-sm "
                                    :class="data.send_invoice ? 'btn-warning text-white' : 'btn-outline-warning'"
                                    @click="
                                        () => {
                                            data.send_invoice = !data.send_invoice
                                            if(!data.send_invoice) {
                                                data.customer_society_id = null
                                                data.company_name = null
                                                data.company_address = {
                                                    address: null,
                                                    cp: null,
                                                    country: null
                                                }
                                            }
                                        }
                                    "
                                    ref="sendInvoiceBtn"
                                >
                                    <i
                                        class="fa fa-xs fa-fw fa-check pe-2"
                                        :class="data.send_invoice ? 'd-inline-block' : 'd-none'"
                                        ref="sendInvoiceIcon"
                                    ></i
                                    >Facture
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="block-content block-content-full text-center">
                        <button
                            type="button"
                            class="btn btn-sm btn-alt-primary text-primary me-1  "
                            data-bs-dismiss="modal"
                            @click="hideModal('encaisser')"
                            :disabled="invoiceRequiresSociety"
                        >
                            Encaisser seulement
                        </button>
                        <button
                            type="button"
                            class=" btn btn-sm btn-primary text-white "
                            data-bs-dismiss="modal"
                            @click="hideModal('cloturer')"
                            :disabled="invoiceRequiresSociety"
                        >
                            Clôturer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['closeSaleModal', 'companyName', 'companyAddress', 'customerSocietyId', 'customerSocieties', 'sendInvoice', 'sendMail', 'parameterThanks'],
    data: () => ({
        isCloseSale: false,
        customer_society_search: '',
        data: {
            close_sale: true,
            customer_society_id: null,
            company_name: null,
            company_address: {
                address: null,
                cp: null,
                country: null,
            },
            rebooking: false,
            notice: false,
            send_mail: false,
            send_invoice: false
        },
    }),
    created() {
        this.data.send_invoice = this.asBoolean(this.sendInvoice)
        this.data.send_mail = this.sendMail
    },
    mounted() {
        this.isCloseSale = this.closeSaleModal
        this.data.customer_society_id = this.customerSocietyId
        this.data.company_name = this.companyName
        this.data.company_address = this.companyAddress
        this.data.rebooking = this.parameterThanks.rebooking
        this.data.notice = this.parameterThanks.notice
    },
    computed: {
        selectedCustomerSociety() {
            return (this.customerSocieties || []).find(society => Number(society.id) === Number(this.data.customer_society_id)) || null
        },
        invoiceRequiresSociety() {
            return this.asBoolean(this.data.send_invoice) && !this.data.customer_society_id
        },
        filteredCustomerSocieties() {
            const search = this.customer_society_search.toLowerCase().trim()
            if (!search) {
                return this.customerSocieties || []
            }

            return (this.customerSocieties || []).filter(society => [
                society.name,
                society.siren,
                society.siret,
                society.email,
                society.city,
                society.postal_code,
            ].filter(Boolean).join(' ').toLowerCase().includes(search))
        },
    },
    methods: {
        applySelectedSociety() {
            const society = this.selectedCustomerSociety
            this.data.company_name = society ? society.name : null
            this.data.company_address = society
                ? {
                    address: society.address,
                    cp: `${society.postal_code || ''} ${society.city || ''}`.trim(),
                    country: society.country,
                }
                : { address: null, cp: null, country: null }
        },
        hideModal(type = null) {
            if (this.invoiceRequiresSociety) {
                return
            }

            if (type == 'encaisser') {
                this.data.close_sale = false
            } else if (type == 'cloturer') {
                this.data.close_sale = true
            }
            this.$emit('close-sale', this.data)

            // this.isCloseSale = !this.isCloseSale
        },
        asBoolean(value) {
            return value === true || value === 1 || value === '1'
        },
    },
    watch: {
        closeSaleModal(newVal) {
            this.isCloseSale = newVal
        },
    },
}
</script>

<style></style>
